/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  DummyMineablePunks,
  DummyMineablePunksInterface,
} from "../DummyMineablePunks";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "punkIdToAssets",
    outputs: [
      {
        internalType: "uint96",
        name: "",
        type: "uint96",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class DummyMineablePunks__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DummyMineablePunks> {
    return super.deploy(overrides || {}) as Promise<DummyMineablePunks>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): DummyMineablePunks {
    return super.attach(address) as DummyMineablePunks;
  }
  connect(signer: Signer): DummyMineablePunks__factory {
    return super.connect(signer) as DummyMineablePunks__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DummyMineablePunksInterface {
    return new utils.Interface(_abi) as DummyMineablePunksInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DummyMineablePunks {
    return new Contract(address, _abi, signerOrProvider) as DummyMineablePunks;
  }
}
